"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dialog = _interopRequireDefault(require("../../Framework/Components/Dialog"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _LoadingOverlay = _interopRequireDefault(require("../../Framework/Components/LoadingOverlay"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    content: {
      padding: '0 !important'
    },
    labels: {},
    option: {
      minHeight: 25,
      display: 'table',
      width: '100%',
      '& $labels': {
        display: 'table-cell',
        verticalAlign: 'middle',
        padding: '0px 5px',
        '& $price': {
          "float": 'right'
        }
      },
      '&.selected': {
        backgroundColor: theme.palette.secondary.lighter
      }
    },
    price: {},
    root: {
      '& .dialog-title-bar': {
        display: 'none'
      }
    }
  };
}, {
  name: 'CustomDialogSelect'
});
var CustomDialogSelect = function CustomDialogSelect(_ref) {
  var isLoading = _ref.isLoading,
    isSelected = _ref.isSelected,
    onSelectOption = _ref.onSelectOption,
    options = _ref.options,
    show = _ref.show,
    selectedOption = _ref.selectedOption,
    selectedOptionProperty = _ref.selectedOptionProperty,
    LoadingComponent = _ref.LoadingComponent;
  var classes = useStyles();
  var isOptionSelected = function isOptionSelected(option) {
    if (isSelected) {
      return isSelected(option);
    }
    if (!selectedOption) {
      return false;
    }

    // if there are more values in the selection
    if ((0, _isArray["default"])(selectedOption)) {
      var _iterator = _createForOfIteratorHelper(selectedOption),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;
          if (selectedOptionProperty) {
            if (v[selectedOptionProperty] === option[selectedOptionProperty]) {
              return true;
            }
          } else {
            if (v === option) {
              return true;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if (selectedOptionProperty) {
      return selectedOption[selectedOptionProperty] === option[selectedOptionProperty];
    } else {
      return selectedOption === option;
    }
  };
  var renderOption = function renderOption(option, key) {
    var selected = isOptionSelected(option);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.option + (selected ? ' selected' : ''),
      key: key,
      "data-option": option.identifier,
      onClick: function onClick() {
        return onSelectOption(option);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.labels
    }, /*#__PURE__*/_react["default"].createElement("span", null, option.title), /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.price
    }, option.priceFormatted)));
  };
  var renderComponent = function renderComponent() {
    return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
      className: classes.root,
      show: show
    }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
      className: classes.content
    }, isLoading ? /*#__PURE__*/_react["default"].createElement(LoadingComponent, {
      show: isLoading
    }) : (0, _isArray["default"])(options) && options.map(function (option, key) {
      return renderOption(option, key);
    })));
  };
  return renderComponent();
};
CustomDialogSelect.defaultProps = {
  onSelectOption: function onSelectOption() {},
  options: [],
  show: false,
  LoadingComponent: _LoadingOverlay["default"]
};
var _default = exports["default"] = CustomDialogSelect;